//node modules
const FooterSection = () => {
  return (
    <section className="w-full flex justify-center bg-black py-12">
      <div className="w-4/5 max-w-screen-xl">
        <img
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          width={163}
          src={require("../../assets/images/footer-logo.png")}
          alt="Ray Sigorta Logo"
          style={{ cursor: "pointer" }}
        />
      </div>
    </section>
  );
};

export default FooterSection;
